import { getAugmentedNamespace } from "./_commonjsHelpers.mjs";
import * as index from "../vendor/@formatjs/intl-localematcher/lib/index.mjs";
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(index);
export {
  require$$1 as default
};
